// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal .modal-content .modal-body {
  text-align: left;
}

@media (max-width: 767px) {
  section.how-to-steps img {
    max-width: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/support/support-rules/support-rules.component.scss"],"names":[],"mappings":"AAGQ;EACI,gBAAA;AAFZ;;AAMA;EAEQ;IACI,eAAA;EAJV;AACF","sourcesContent":["\n.modal{\n    .modal-content{\n        .modal-body{\n            text-align: left;\n        }\n    }\n}\n@media (max-width: 767px) { \n    section.how-to-steps{\n        img{\n            max-width: 50px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
